import React from 'react';
import Tabela from '~/Components/TabelaDinamica/Tabela';
import { format } from '~/Utils/Helpers';

// Valor #,###,##0.00 (paridade FormatFloat, UConsultaJudicial.pas:242/280).
const fmtValor = v =>
  Number(v || 0).toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const fmtData = d => (d ? format.date(d, 'DD/MM/YYYY') : '');

const ouTraco = v => (v === null || v === undefined || v === '' ? '—' : v);

/**
 * GridAcordoJudicial — colunas do DFM RxDBGrid1 (UConsultaJudicial.dfm). Read-only.
 * `prestador`/`ultcont` podem vir nulos (boleto sem cobrador ativo — CAF 2334): exibe "—".
 * "Último Contato" exibido por default (TechSpec §3); omitir só por decisão do operador.
 */
const GridAcordoJudicial = ({ itens = [] }) => {
  const colunas = [
    {
      key: 'prestador',
      title: 'Cobrador',
      ordenacao: true,
      align: 'right',
      render: value => ouTraco(value),
    },
    {
      key: 'nomprest',
      title: 'Nome',
      ordenacao: true,
      render: value => ouTraco(value),
    },
    { key: 'emp', title: 'Empreendimento', ordenacao: true },
    { key: 'ql', title: 'QL', ordenacao: true, align: 'center' },
    { key: 'cliente', title: 'Cliente', ordenacao: true, align: 'right' },
    { key: 'apelido_conta', title: 'Apelido', ordenacao: true },
    { key: 'boleto', title: 'Boleto', ordenacao: true, align: 'right' },
    { key: 'parc', title: 'Parc', ordenacao: true, align: 'right' },
    {
      key: 'valor',
      title: 'Valor',
      ordenacao: true,
      align: 'right',
      render: value => fmtValor(value),
    },
    { key: 'dias', title: 'Dias', ordenacao: true, align: 'right' },
    {
      key: 'ultcont',
      title: 'Último Contato',
      ordenacao: true,
      align: 'center',
      render: value => fmtData(value),
    },
  ];

  return <Tabela colunas={colunas} dados={itens} striped hover />;
};

export default GridAcordoJudicial;
